import wixWindow from 'wix-window';
// import wixLocation from 'wix-location';

// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

	// show menu button only for mobile
	if(wixWindow.formFactor === "Mobile"){
		$w("#PhoneIcon").show();
		$w("#CircleIcon").show();
	}
	else {
		$w("#PhoneIcon").hide();
		$w("#CircleIcon").hide();
	}
	
	// hide contact button on contact page
	// if(wixLocation.prefix === "contact"){
	// 	$w("#button3").hide();
	// }
	// else {
	// 	$w("#button3").show();
	// }
});